module.exports = __webpack_public_path__ + "static/media/protagonistdepth.b0d60a54.vert";